'use client';

import React__default from 'react';

var DefaultAvatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 110 : _b;
    return (React__default.createElement("svg", { width: size, height: size, viewBox: '0 0 110 110', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("rect", { x: '10', y: '10', width: '90', height: '90', rx: '45', fill: '#E6EFFF' }),
        React__default.createElement("path", { d: 'M55.9759 54.1993C62.3237 54.1993 67.8409 48.5041 67.8409 41.0884C67.8409 33.7618 62.3237 28.3335 55.9759 28.3335C49.6281 28.3335 44.1109 33.8804 44.1109 41.1477C44.1109 48.5041 49.5984 54.1993 55.9759 54.1993ZM37.3181 81.6668H74.5743C79.261 81.6668 80.9221 80.332 80.9221 77.7217C80.9221 70.0688 71.3411 59.5089 55.9462 59.5089C40.581 59.5089 31 70.0688 31 77.7217C31 80.332 32.6611 81.6668 37.3181 81.6668Z', fill: '#CCDEFF' })));
};
var DefaultAvatar$1 = React__default.memo(DefaultAvatar);

export { DefaultAvatar$1 as default };
//# sourceMappingURL=index.js.map
